module.exports = __webpack_public_path__ + "img/exit-icon-white.94c84f03.svg";